<template>
  <div class="w-full h-full flex overflow-auto">
    <div class="w-full max-h-full px-4">
      <div class="flex flex-col bg-white pt-4 z-50">
        <div class="flex">
          <div class="flex w-full justify-start mb-4">
            <h1 style="color: darkblue">Galería</h1>
          </div>
        </div>
      </div>

      <!-- Gallery -->
      <div class="w-full">
        <nav class="text-sm flex justify-start">
          <a
            @click="mediaType = 'Imagenes'"
            class="inline-block px-4 py-2"
            v-bind:class="[
              mediaType === 'Imagenes'
                ? 'border-b-2 border-indigo-600 text-indigo-600 font-semibold'
                : 'text-gray-700 hover:text-black',
            ]"
            href="#"
            >Imágenes</a
          >
          <a
            @click="mediaType = 'Videos'"
            class="inline-block px-4 py-2"
            v-bind:class="[
              mediaType === 'Videos'
                ? 'border-b-2 border-indigo-600 text-indigo-600 font-semibold'
                : 'text-gray-700 hover:text-black',
            ]"
            href="#"
            >Videos</a
          >
        </nav>
      </div>

      <div
        v-show="mediaType === 'Imagenes'"
        class="grid gap-4 grid-cols-5 z-50 pb-4"
      >
        <template v-for="(register, index) in multimedia">
          <div
            v-if="register.mimeType.includes('image')"
            class="border-2 shadow-md rounded flex flex-col justify-center items-center"
            :key="'galleryMm' + index"
          >
            <span
              class="py-2 text-primary-color text-sm font-bold tracking-wide"
            >
              {{ register.nombre }}
            </span>
            <v-lazy-image
              :src="replaceURL(register.fileName, 'img')"
              class="rounded object-contain"
              style="width: 250px; height: 250px"
              @error="loadDefaultImg"
            />
            <div class="flex flex-col py-2">
              <span class="text-primary-color-dark text-sm">
                {{ register.nombre_usuario }} {{ register.apellido_usuario }}
              </span>
              <span class="text-gray-500 text-xs">
                {{ register.TDate }}
              </span>
            </div>
            <div class="pb-2">
              <!-- <button
                @click="zoomOnMap(register)"
                class="px-4 py-2 bg-primary-color text-white rounded text-sm"
              >
                Ver en mapa
              </button> -->
              <a
                :href="replaceURLMapByLevantamiento(register)"
                target="_blank"
                class="px-4 py-2 bg-primary-color text-white rounded text-sm"
                >Ver en mapa</a
              >
            </div>
          </div>
        </template>
      </div>

      <div
        v-show="mediaType === 'Videos'"
        class="grid gap-4 grid-cols-5 z-50 pb-4"
      >
        <template v-for="(register, index) in multimedia">
          <div
            v-if="register.mimeType.includes('video')"
            class="border-2 shadow-md rounded flex flex-col justify-center items-center"
            :key="'galleryMm' + index"
          >
            <span
              class="py-2 text-primary-color text-sm font-bold tracking-wide"
            >
              {{ register.nombre }}
            </span>
            <video
              :src="replaceURL(register.fileName, 'video')"
              class="rounded object-contain"
              style="width: 250px; height: 250px"
              controls
            ></video>
            <div class="flex flex-col py-2">
              <span class="text-primary-color-dark text-sm">
                {{ register.nombre_usuario }} {{ register.apellido_usuario }}
              </span>
              <span class="text-gray-500 text-xs">
                {{ register.TDate }}
              </span>
            </div>
            <div class="pb-2">
              <!-- <button
                @click="zoomOnMap(register)"
                class="px-4 py-2 bg-primary-color text-white rounded text-sm"
              >
                Ver en mapa
              </button> -->
              <a
                :href="replaceURLMapByLevantamiento(register)"
                class="px-4 py-2 bg-primary-color text-white rounded text-sm"
                >Ver en mapa</a
              >
            </div>
          </div>
        </template>
      </div>
      <!-- Gallery -->
    </div>
  </div>
</template>

<script>
export default {
  name: "gallery-grid",
  data() {
    return {
      mediaType: "Imagenes",
      showingMultimedia: false,
      currentMultimedia: {},
    };
  },
  props: {
    multimedia: {
      required: true,
    },
  },
  components: {},
  methods: {
    replaceURL(path, type) {
      if (type === "video") {
        return path.replace("./", "apidev/");
      } else {
        let lastIndex = path.lastIndexOf(".");
        let beforeStr = path.slice(0, lastIndex);
        let afterStr = path.slice(lastIndex + 1);
        let resizePath = beforeStr + "_resize." + afterStr;
        return resizePath.replace("./", "apidev/");
      }
    },
    loadDefaultImg(event) {
      event.target.src = "@/assets/default-image-sm.jpg";
    },
    replaceURLMapByLevantamiento(register) {
      return `../compartir/${btoa(register.id)}`;
      //return `http://miapptsil.miatsil.org.mx/levantamientos/${register.usuario_id}`
    },
  },
};
</script>
